// Dr. Frankenstein "build-a-character" worksheet, as spinnable columns.
export const FRANK_COLUMNS = ["Character", "Physical", "Voice", "Prop"];

const CHARACTER = [
  "Barbie Doll", "Alien", "Robot", "Mouse", "Fairy", "Baby / Toddler", "Rockstar", "Rapper",
  "Mad Scientist", "Pirate", "Superhero", "Snowman", "Fitness Instructor", "Clown", "Elderly Person",
  "Spy / Secret Agent", "Queen", "King", "Cowboy / Cowgirl", "Radio DJ", "Ghost", "Vampire",
  "Werewolf", "Zombie",
];

const PHYSICAL = [
  "Claps", "Jazz hands", "Snaps fingers", "Itchy", "Fist pumps", "Sweaty", "Cold", "Dances",
  "Flips hair", "Winks", "Blows kisses", "Smacks gum", "Swimming arms", "Sneezes", "Teeth chatter",
  "Slow motion", "Shows off muscles", "Blows raspberries", "Picks nose (pretend)", "Tips hat",
  "Brushes shoulders off", "Dabs", "Pinky up", "Chants", "Whispers", "Winded", "Yells", "Rhymes",
];

const VOICE = [
  "Southern", "British", "French", "Italian", "Low & booming", "High pitched", "Snorts",
  "Valley girl", "Little kid", "Repeats everything", "Sing-songy", "Elderly", "Angry", "Cheering",
  "Worried", "Flirty", "Evil", "Announcer", "New York",
];

const PROP = [
  "Snake", "Boom box", "Yo-yo", "Basketball", "Chicken leg", "Guitar", "Camera", "Cigar", "Flowers",
  "Ice pack", "Dumbbell(s)", "Comb", "Lipstick", "Mirror", "Sword", "Tape measure", "Stopwatch",
  "Light saber", "Pillow", "Tiny coffee cup", "Deodorant", "Breath spray", "Cymbals", "Tarantula",
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function drawFrankenstein() {
  return {
    category: "Your creation",
    scene_parts: [
      { category: "Character", text: pick(CHARACTER) },
      { category: "Physical move", text: pick(PHYSICAL) },
      { category: "Voice", text: pick(VOICE) },
      { category: "Prop", text: pick(PROP) },
    ],
    spin_pool: [...CHARACTER, ...PHYSICAL, ...VOICE, ...PROP],
  };
}
